import React from 'react';
import Title from '../Title';
import TeamSlider from './TeamSlider';
import { useTranslation } from 'react-i18next';

const Team = () => {
  const { t } = useTranslation();
  return (
    <section className='flex flex-col p-6 md:p-12 gap-6 md:gap-12'>
     <Title>{t('team.team_title')}</Title>
      <TeamSlider />
    </section>
  );
};

export default Team;